const PAUSE_ALLOWANCE_MS = 4 * 60 * 60 * 1000;

// Eligibility only: authorization and signature verification remain server/CDN concerns.
export function getSignedMediaExpiryMs(url) {
  try {
    const parsed = new URL(url);
    const params = parsed.searchParams;
    const expires = params.getAll('Expires');
    if (parsed.protocol !== 'https:' || params.has('Policy') ||
        !params.get('Signature') || !params.get('Key-Pair-Id') ||
        expires.length !== 1 || !/^[0-9]+$/.test(expires[0])) return null;
    const seconds = Number(expires[0]);
    const milliseconds = seconds * 1000;
    return seconds > 0 && Number.isSafeInteger(seconds) && Number.isSafeInteger(milliseconds)
      ? milliseconds : null;
  } catch {
    return null;
  }
}

export function getAirPlayEligibility({
  url, duration, currentTime, accessExpiresAt = null,
  hasSubtitle = false, hasAudioDescription = false, nowMs = Date.now(),
  pauseAllowanceMs = PAUSE_ALLOWANCE_MS,
}) {
  const cdnExpiry = getSignedMediaExpiryMs(url);
  const shareExpiry = accessExpiresAt === null ? null : Date.parse(accessExpiresAt);
  const expiresAtMs = cdnExpiry === null || (shareExpiry !== null && !Number.isFinite(shareExpiry))
    ? null : shareExpiry === null ? cdnExpiry : Math.min(cdnExpiry, shareExpiry);
  const result = (reason) => ({ allowed: reason === null, reason, expiresAtMs });
  if (hasAudioDescription) return result('audio_description');
  if (hasSubtitle) return result('captions');
  const seconds = Number(duration);
  if (!Number.isFinite(seconds) || seconds <= 0) return result('unknown_duration');
  if (expiresAtMs === null || !Number.isFinite(nowMs)) return result('unknown_expiry');
  if (shareExpiry !== null && shareExpiry <= nowMs) return result('access_expired');
  if (expiresAtMs <= nowMs) return result('insufficient_validity');
  const time = Number.isFinite(currentTime) ? Math.min(seconds, Math.max(0, currentTime)) : 0;
  const requiredMs = (seconds - time) * 1000 + pauseAllowanceMs;
  return result(expiresAtMs - nowMs >= requiredMs ? null : 'insufficient_validity');
}
